import type { DocMigration } from "../docMigration";

// copied from lib/options/systemOptionSetEnum.ts
enum SystemOptionSet {
  ELEVATION_STYLE = "elevationStyle",
  MIRROR = "mirror",
  INTERIOR_PALETTE = "interiorPalette",
}

// copied from lib/options/settingsOptionSet.ts
const SETTINGS_OPTION_SET_SUFFIX = "settingsParam";

// copied from lib/options/systemOptionSet.ts
function isSystemOptionSet(id): boolean {
  return Object.values<string>(SystemOptionSet).includes(id) || id.endsWith(SETTINGS_OPTION_SET_SUFFIX);
}

function isElevationOptionSet(optionSetId: string): boolean {
  return optionSetId === SystemOptionSet.ELEVATION_STYLE;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_349: DocMigration = {
  maxSchemaVersion: "0.0.349",
  description: "Fix any malformed DocAuxOptionSet object in auxOptionSets table",
  apply(json: any) {
    for (const id in json.optionSets ?? {}) {
      let optionSetType: null | string = null;
      if (isElevationOptionSet(id)) {
        optionSetType = "ELEVATION";
      } else if (isSystemOptionSet(id)) {
        optionSetType = "SYSTEM";
      } else {
        optionSetType = "USER";
      }
      (json.optionSets as any)[id].optionSetType = optionSetType;
    }

    return json;
  },
};

export default migration_0_0_349;
